export default "__VITE_ASSET__HFdy9NjI__"